import { render } from "./RecurringPaymentsPage.vue?vue&type=template&id=08a3857c&scoped=true"
import script from "./RecurringPaymentsPage.vue?vue&type=script&lang=js"
export * from "./RecurringPaymentsPage.vue?vue&type=script&lang=js"

import "./RecurringPaymentsPage.vue?vue&type=style&index=0&id=08a3857c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a3857c"]])

export default __exports__